import { view } from '@yola/ws-sdk';
import {
  ASPECT_RATIO_ATTRIBUTE,
  CONTENT_POSITION_ATTRIBUTE,
  WIDTH_ATTRIBUTE,
} from 'src/js/modules/extensions/registry/ws-image/constants/media-container';

const getResizeOperations = (elements) => {
  const { setElementAttribute, removeElementAttribute } = view.operations;

  return elements
    .map((element) => {
      const operationList = [];
      const elementId = view.accessors.getLiveElementId(element);

      operationList.push([
        setElementAttribute,
        [elementId, ASPECT_RATIO_ATTRIBUTE, element.getAttribute(ASPECT_RATIO_ATTRIBUTE)],
      ]);

      if (element.matches('ws-media-container')) {
        operationList.push([
          setElementAttribute,
          [elementId, CONTENT_POSITION_ATTRIBUTE, element.getAttribute(CONTENT_POSITION_ATTRIBUTE)],
        ]);
      }

      let widthInstruction;

      if (element.hasAttribute(WIDTH_ATTRIBUTE)) {
        widthInstruction = [
          setElementAttribute,
          [elementId, WIDTH_ATTRIBUTE, element.getAttribute(WIDTH_ATTRIBUTE)],
        ];
      } else {
        widthInstruction = [removeElementAttribute, [elementId, WIDTH_ATTRIBUTE]];
      }

      operationList.push(widthInstruction);

      return operationList;
    })
    .flat();
};

export default getResizeOperations;
